import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { useTranslate } from '@awardit/react-use-translate';
import { useSendMessage } from 'crustate/react';
import { addMessage } from '@crossroads/shop-state/messages';
import { Spinner } from '@crossroads/ui-components';
import { checkoutToken } from '../../queries/altapay.graphql.js';
import { appendScript } from '../../helpers/append-altapay-script.js';
import { parseErrorCode } from '../../helpers/utils.js';

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _continueIgnored(value) {
  if (value && value.then) {
    return value.then(_empty);
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var HandleAltapayRedirect = _ref => {
  function _temp4(e) {
    console.error("Error when fetching session data", e);
    push(t("URL.CHECKOUT_FAILED"));
    sendMessage(addMessage("PLACE_ORDER_CATCH", "error"));
  }

  function _temp3() {
    return _invokeIgnored(_temp2);
  }

  function _temp2() {
    if (typeof querySessionId === "string") {
      return _awaitIgnored(client(checkoutToken, {
        sessionId: querySessionId
      }).then(_temp));
    }
  }

  function _temp(data) {
    if (data.checkoutToken) {
      setToken(data.checkoutToken);
    } else {
      push(t("URL.CHECKOUT_FAILED"));
      sendMessage(addMessage("PLACE_ORDER_CATCH", "error"));
    }
  }

  var client = _ref.client,
      scriptURL = _ref.scriptURL,
      querySessionId = _ref.querySessionId,
      redirectData = _ref.redirectData;

  var _useState = useState(null),
      token = _useState[0],
      setToken = _useState[1];

  var _useHistory = useHistory(),
      push = _useHistory.push;

  var t = useTranslate();
  var sendMessage = useSendMessage();

  var fetchCheckoutToken = _async(function () {
    return _continueIgnored(_catch(_temp3, _temp4));
  });

  useEffect(() => {
    appendScript(scriptURL);
    fetchCheckoutToken();
  }, []);

  var initPaymentMethodSDK = () => {
    var _window$Altapay;

    console.log("init", token, querySessionId);
    (_window$Altapay = window.Altapay) == null ? void 0 : _window$Altapay.init(token, querySessionId).setCallbacks(AltaPayFactory.getCallbacksBuilder().setSuccess(() => {
      push(t("URL.CHECKOUT_SUCCESS"));
    }).setFailure(event => {
      var errorMessage = parseErrorCode(event);
      sendMessage(addMessage(errorMessage, "error"));
      push(t("URL.CHECKOUT_FAILED"));
    }).setBodyFormat("JSON").build()).handleRedirectData(redirectData);
  };

  useEffect(() => {
    var loadAltapaySDK = setInterval(() => {
      clearInterval(loadAltapaySDK);

      if (window.Altapay && token && querySessionId) {
        initPaymentMethodSDK();
      }
    }, 1000);
  }, [token, querySessionId]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(Spinner, {
    className: "paymentSpinner",
    variant: "primary"
  });
};

export { HandleAltapayRedirect };
//# sourceMappingURL=index.js.map
